import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";

import { TableHeaderComponent } from "./saq/headers/section_2b/table_header.component";
import { SectionSubtitleHeaderComponent } from "./saq/headers/section_2b/section_subtitle.component";
import { SaqQuestionMainComponent as Section2bQuestionMainComponent } from "./saq/questions/section_2b/main.component";
import { SaqQuestionMainComponent as AppendixAQuestionMainComponent } from "./saq/questions/appendix_a/main.component";
import { FollowUpModalComponent } from "./utils/follow_up_modal.component";
import { MerchantDetailsUpdateModalComponent } from "./utils/merchant_details_update_modal.component";
import { NeedsReviewModalComponent } from "./utils/needs_review_modal.component";
import { ResultsDescriptionFooterComponent } from "./saq/footers/section_2b/results_description.component";
import { SupportingDocumentationFooterComponent } from "./saq/footers/supporting_documentation.component";
import { AssessorNotesFooterComponent } from "./notes/assessor_notes.component";
import { RecentActivityFooterComponent } from "./activity/recent_activity.component";
import { TaskAssignmentsFooterComponent } from "./task_assignments/task_assignments_footer.component";
import { Section2bCheckboxesComponent } from "../form_fields/saq/section_2b_checkboxes.component";
const DECLARED_COMPONENTS = [
    TableHeaderComponent,
    SectionSubtitleHeaderComponent,
    Section2bQuestionMainComponent,
    AppendixAQuestionMainComponent,
    FollowUpModalComponent,
    MerchantDetailsUpdateModalComponent,
    NeedsReviewModalComponent,
    ResultsDescriptionFooterComponent,
    Section2bCheckboxesComponent,
];

const STANDALONE_COMPONENTS = [
    SupportingDocumentationFooterComponent,
    AssessorNotesFooterComponent,
    RecentActivityFooterComponent,
    TaskAssignmentsFooterComponent,
];

@NgModule({
    declarations: DECLARED_COMPONENTS,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NzButtonModule,
        NzFormModule,
        NzInputModule,
        NzIconModule,
        NzModalModule,
        NzSpinModule,
        NzCheckboxModule,
        ...STANDALONE_COMPONENTS
    ],
    exports: [...DECLARED_COMPONENTS, ...STANDALONE_COMPONENTS],
})
export class QuestionTemplatesModule {}
